import EventBus from '@/utils/EventBus'

export default {
    data() {
        return {
            isLoadingButton: false,
        }
    },
    mounted() {
        document.addEventListener('message', this.handleMessage)
    },
    methods: {
        showNotification(text, type) {
            const param = {
                text: text,
                type: type,
            }
            EventBus.$emit('show-notications', param)
        },

        handleMessage(event) {
            const resp = JSON.parse(event.data)
            if (resp.command === 'print-status') {
                // toast is now handled globally in App.vue handleMessage('print-status')
                // if (resp.code === 200) {
                //     this.showNotification('Print success', 'success')
                // } else {
                //     this.showNotification('Print error', 'error')
                // }
                this.isLoadingButton = false
            }
        },
    },
}
